var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,160h441.4L356.7,260.7c-6.2,6.2-6.2,16.4,0,22.6s16.4,6.2,22.6,0l128-128c3.1-3.1,4.7-7.2,4.7-11.3 s-1.6-8.2-4.7-11.3l-128-128c-6.2-6.2-16.4-6.2-22.6,0s-6.2,16.4,0,22.6L457.4,128H16c-8.8,0-16,7.2-16,16S7.2,160,16,160z M496,352 H54.6l100.7-100.7c6.2-6.2,6.2-16.4,0-22.6s-16.4-6.2-22.6,0l-128,128C1.6,359.8,0,363.9,0,368s1.6,8.2,4.7,11.3l128,128 c6.2,6.2,16.4,6.2,22.6,0s6.2-16.4,0-22.6L54.6,384H496c8.8,0,16-7.2,16-16S504.8,352,496,352z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare2);
export default __webpack_public_path__ + "static/media/share2.442dc47255604afe1ab62fb2239ce435.svg";
export { ForwardRef as ReactComponent };